import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { id: "PaginationComponent" }


import { IPageInfo } from "@/models/base";
import { IVocabulary } from "@/models/IIearnEnglish";
import { PropType } from "vue";
import { SCROLL_TO } from "@/utils/global";


export default /*@__PURE__*/_defineComponent({
  __name: 'PaginationComponent',
  props: {
  pageInfo: {
    type: Object as PropType<IPageInfo<IVocabulary> | undefined>,
    required: false,
  },
},
  emits: ["pageChange", "pageSizeChange"],
  setup(__props, { emit: __emit }) {


const emit = __emit;
const handlePageChange = (page: number) => {
  SCROLL_TO.TOP();
  emit("pageChange", page);
};
const handlePageSizeChange = (current: number, pageSize: number) => {
  SCROLL_TO.TOP();
  emit("pageSizeChange", { current, pageSize });
};

return (_ctx: any,_cache: any) => {
  const _component_a_pagination = _resolveComponent("a-pagination")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_a_pagination, {
      current: Number(__props.pageInfo?.page) ?? 1,
      pageSize: Number(__props.pageInfo?.pageSize ?? 10),
      total: Number(__props.pageInfo?.totalCount) || 0,
      onChange: handlePageChange,
      "show-size-changer": "",
      onShowSizeChange: handlePageSizeChange,
      class: "flex justify-center mt-4"
    }, null, 8, ["current", "pageSize", "total"])
  ]))
}
}

})